import { createContext } from 'react'

export const InternalDebugPortalContext = createContext<{
  debugElementsRoot: HTMLElement | null
  setDebugElementsRoot: (element: HTMLElement | null) => void
}>({
  debugElementsRoot: null,
  setDebugElementsRoot: () => {
    return
  },
})
InternalDebugPortalContext.displayName = 'DebugPortal'
